import { Box, Divider, Stack, VStack, useColorModeValue } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';
import { SidebarMenuItem } from './SidebarMenuItem';

export const SidebarUnauthenticated = () => {
  return (
    <Box as="section" bg="bg-canvas" overflowY="auto" height="full">
      <VStack
        bg="bg-surface"
        boxSizing="border-box"
        boxShadow={useColorModeValue('sm', 'sm-dark')}
        minH={'100%'}
        py={{ base: '6', sm: '8' }}
        px={{ base: '4', sm: '6' }}
        pb={'80px'}>
        <Stack justify="space-between" spacing="5" width="full">
          <Stack spacing={'10'} shouldWrapChildren>
            <Link to={ROUTES.dashboard}>
              {/* Use react-router-dom link so that we don't refetch getConsolidatedInvestor on navigation */}
              <Image image="logo-black" width={['100px', '166px']} cursor="pointer" />
            </Link>
          </Stack>

          <Stack spacing={{ base: '5', sm: '6' }}>
            <Divider />
            <SidebarMenuItem label="Sign In" icon="right-from-bracket" route={ROUTES.signin} />
          </Stack>
        </Stack>
      </VStack>
    </Box>
  );
};
